<template>
  <div :class="`task-card flex-box flex-col ju-sb ${activeReport.id === cardData.id ? 'active' : ''}`">
    <div :class="`card-tag ${handleTagStyle}`" v-if="this.cardData.status !== '1'">{{handleReportStatus}}</div>
    <div class="report-name">{{cardData.reportName}}</div>
    <div class="flex-box ju-sb ">
      <div style="color: #B5B5B5">{{cardData.reportUserNum}}人上报/{{cardData.reportUserTotal}}人</div>
      <div class="flex-box al-c f10">
        <div>上报率</div>        
        <div class="progress-box ml5 ">
          <el-progress :percentage="handleReportRate"></el-progress>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "taskCard",
  props: {
    cardData: Object,
    activeReport: Object,
  },
  data() {
    return {
    };
  },
  created(){
  },
  computed: {
    handleTagStyle(){
      switch (this.cardData.status) {
        case '0':
          return 'red'
        case '1':
          return ''
        case '2':
          return 'gray'
        case '3':
          return 'orange'
        case '4':
          return 'purple'
        default:
          return '';
      }
    },
    handleReportStatus(){
      switch (this.cardData.status) {
        case '0':
          return '完结'
        case '1':
          return '办理中'
        case '2':
          return '暂停'
        case '3':
          return '中止'
        case '4':
          return '系统中止'
        default:
          return '';
      }
    },
    handleReportRate(){
      const val = this.cardData.reportRate
      if(!val){
        return 0;
      }
      return Number(val.substring(0, val.length-1))
    },
  },
  methods: {},
  watch: {},
  filters: {}
}
</script>

<style scoped>
.task-card {
  height: 58px;
  background-color: #F2F3F6;
  border-radius: 4px;
  padding: 10px 0 10px 16px;
  font-size: 12px;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  margin-bottom: 8px;
  cursor: pointer;
}
.card-tag {
  /* content: '已结束';
  display: block; */
  position: absolute;
  color: #fff;
  width: 80px;
  line-height: 18px;
  text-align: center;
  top: 5px;
  right: -26px;
  transform: rotate(45deg) scale(0.8);
}
.red {
  background-color: #FC7357;
}
.green {
  background-color: #1afa29;
}
.gray {
  background-color: #999999;
}
.orange {
  background-color: #FF8400;
}
.purple {
  background-color: #d4237a;
}
.progress-box {
  width: 110px;
}
.task-card /deep/ .el-progress__text {
  font-size: 10px !important;
}
.f10 {
  font-size: 10px;
}
.report-name {
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.active::after {
  display: block;
  content: '';
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  border: #49A0FA 2px solid;
  border-radius: 4px;
}
</style>